export const COMMON_ADJECTIVES = [
  'abandoned',
  'able',
  'abnormal',
  'abrasive',
  'absent',
  'absorbent',
  'abstract',
  'absurd',
  'abundant',
  'acceptable',
  'accessible',
  'accidental',
  'accurate',
  'aching',
  'acidic',
  'acoustic',
  'acrobatic',
  'active',
  'actual',
  'addictive',
  'adequate',
  'adjacent',
  'adjustable',
  'admirable',
  'adorable',
  'advanced',
  'adventurous',
  'aerial',
  'affectionate',
  'afraid',
  'aged',
  'ageless',
  'aggressive',
  'agile',
  'airtight',
  'airy',
  'alarming',
  'alert',
  'alien',
  'alive',
  'alkaline',
  'allergic',
  'alone',
  'alpine',
  'alternate',
  'amazing',
  'amber',
  'ambitious',
  'ample',
  'amused',
  'ancient',
  'angry',
  'angular',
  'animated',
  'annoying',
  'annual',
  'anonymous',
  'antique',
  'anxious',
  'appealing',
  'approved',
  'aquatic',
  'arctic',
  'arid',
  'armored',
  'aromatic',
  'artificial',
  'artistic',
  'ascending',
  'ashen',
  'ashy',
  'astounding',
  'athletic',
  'attached',
  'attentive',
  'authentic',
  'automatic',
  'available',
  'average',
  'awake',
  'awful',
  'awkward',
  'azure',
  'backlit',
  'backward',
  'bacterial',
  'baggy',
  'baked',
  'balanced',
  'bald',
  'balmy',
  'bandaged',
  'barbed',
  'bare',
  'barren',
  'bashful',
  'basic',
  'battered',
  'beady',
  'beaming',
  'beautiful',
  'beefy',
  'beloved',
  'bendy',
  'beneficial',
  'bent',
  'big',
  'billowy',
  'binding',
  'bitten',
  'bitter',
  'black',
  'blackened',
  'bland',
  'blank',
  'blazing',
  'bleached',
  'bleak',
  'blessed',
  'blind',
  'blinding',
  'blistering',
  'bloated',
  'blonde',
  'bloodshot',
  'bloody',
  'blossoming',
  'blotchy',
  'blue',
  'blunt',
  'blushing',
  'boggy',
  'boiling',
  'boisterous',
  'bold',
  'boneless',
  'bony',
  'bookish',
  'bored',
  'boring',
  'bossy',
  'botanical',
  'bottomless',
  'bouncy',
  'boundless',
  'boxed',
  'braided',
  'brainy',
  'branded',
  'brash',
  'brassy',
  'brave',
  'breathless',
  'breezy',
  'bright',
  'brilliant',
  'briny',
  'brisk',
  'bristly',
  'brittle',
  'broad',
  'broken',
  'bronze',
  'brooding',
  'brown',
  'bruised',
  'bubbling',
  'bubbly',
  'budding',
  'bulging',
  'bulky',
  'bumbling',
  'bumpy',
  'buoyant',
  'buried',
  'burning',
  'burnt',
  'bursting',
  'bushy',
  'bustling',
  'busy',
  'buttery',
  'buzzing',
  'calculated',
  'calm',
  'candid',
  'capable',
  'captive',
  'caramel',
  'carefree',
  'careful',
  'careless',
  'caring',
  'carpeted',
  'carved',
  'casual',
  'cautious',
  'cellular',
  'central',
  'ceramic',
  'chalky',
  'charcoal',
  'charged',
  'charitable',
  'charming',
  'chatty',
  'cheap',
  'cheeky',
  'cheerful',
  'cheesy',
  'chemical',
  'cherished',
  'chewed',
  'chewy',
  'childish',
  'chilly',
  'chipped',
  'choppy',
  'chosen',
  'chronic',
  'chubby',
  'chunky',
  'circular',
  'civic',
  'civilized',
  'clammy',
  'classic',
  'classy',
  'clean',
  'clear',
  'clever',
  'clingy',
  'clinical',
  'clipped',
  'clogged',
  'cloudy',
  'clueless',
  'clumsy',
  'clunky',
  'cluttered',
  'coarse',
  'coastal',
  'cobbled',
  'cocky',
  'coded',
  'coherent',
  'coiled',
  'cold',
  'collective',
  'colonial',
  'colorful',
  'colossal',
  'combined',
  'combustible',
  'comfortable',
  'commanding',
  'commercial',
  'common',
  'communal',
  'compact',
  'comparable',
  'compelling',
  'complete',
  'complicated',
  'composed',
  'concealed',
  'concerned',
  'concrete',
  'condensed',
  'confident',
  'confirmed',
  'confused',
  'conical',
  'connected',
  'conscious',
  'consecutive',
  'considerable',
  'consistent',
  'conspicuous',
  'constant',
  'content',
  'continental',
  'continuous',
  'controlled',
  'convenient',
  'conventional',
  'converted',
  'convertible',
  'convincing',
  'cool',
  'cooperative',
  'copper',
  'coral',
  'cordial',
  'corny',
  'corroded',
  'corrugated',
  'cosmic',
  'costly',
  'counterfeit',
  'countless',
  'courageous',
  'courteous',
  'covered',
  'covert',
  'cowardly',
  'cozy',
  'cracked',
  'crackling',
  'crafty',
  'cramped',
  'cranky',
  'crazy',
  'creaky',
  'creamy',
  'creative',
  'creepy',
  'crescent',
  'crimson',
  'crisp',
  'crispy',
  'critical',
  'crooked',
  'cross',
  'crowded',
  'crucial',
  'crude',
  'cruel',
  'crumbly',
  'crumpled',
  'crunchy',
  'crusty',
  'cubic',
  'cuddly',
  'cultural',
  'cumulative',
  'curious',
  'curly',
  'current',
  'cursed',
  'curved',
  'customary',
  'cute',
  'cylindrical',
  'daily',
  'dainty',
  'damaged',
  'damp',
  'dangerous',
  'dapper',
  'daring',
  'dark',
  'darkened',
  'dashing',
  'dazed',
  'dazzling',
  'dead',
  'deadly',
  'deaf',
  'dear',
  'decayed',
  'deceitful',
  'decent',
  'declining',
  'decorative',
  'dedicated',
  'deep',
  'defensive',
  'defiant',
  'definite',
  'deliberate',
  'delicate',
  'delicious',
  'delightful',
  'demanding',
  'dense',
  'dependable',
  'depleted',
  'depressed',
  'derived',
  'deserted',
  'desirable',
  'desolate',
  'desperate',
  'detailed',
  'determined',
  'devoted',
  'dewy',
  'diagonal',
  'different',
  'difficult',
  'digital',
  'dignified',
  'diligent',
  'dim',
  'diminished',
  'dingy',
  'dinky',
  'diplomatic',
  'direct',
  'dirty',
  'disabled',
  'disastrous',
  'discreet',
  'disguised',
  'dismal',
  'disposable',
  'distant',
  'distinct',
  'distorted',
  'disturbing',
  'diverse',
  'divine',
  'dizzy',
  'dizzying',
  'domestic',
  'dominant',
  'dorky',
  'dormant',
  'dotted',
  'double',
  'doubtful',
  'dowdy',
  'downhill',
  'downtown',
  'drab',
  'drafty',
  'dramatic',
  'dreadful',
  'dreamy',
  'dreary',
  'drenched',
  'dried',
  'dripping',
  'driven',
  'droopy',
  'drowsy',
  'drumming',
  'dry',
  'dual',
  'dull',
  'dumb',
  'durable',
  'dusty',
  'dutiful',
  'dynamic',
  'eager',
  'early',
  'earnest',
  'earthen',
  'earthy',
  'eastern',
  'easy',
  'eccentric',
  'economical',
  'edgy',
  'educated',
  'eerie',
  'effective',
  'efficient',
  'elaborate',
  'elastic',
  'elderly',
  'electric',
  'elegant',
  'elevated',
  'eligible',
  'elongated',
  'embarrassed',
  'emerging',
  'emotional',
  'empty',
  'enabled',
  'enchanted',
  'enclosed',
  'encouraged',
  'endangered',
  'endless',
  'energetic',
  'engaging',
  'enjoyable',
  'enlightened',
  'enormous',
  'entertaining',
  'entire',
  'envious',
  'epic',
  'equal',
  'equipped',
  'erratic',
  'essential',
  'eternal',
  'even',
  'eventual',
  'everyday',
  'evident',
  'evil',
  'evolved',
  'exact',
  'exaggerated',
  'excellent',
  'exceptional',
  'excessive',
  'exchangeable',
  'excited',
  'exclusive',
  'exhausted',
  'existing',
  'exotic',
  'expanded',
  'expected',
  'expensive',
  'experimental',
  'expert',
  'explosive',
  'exposed',
  'expressive',
  'extended',
  'extensive',
  'external',
  'extinct',
  'extraordinary',
  'extreme',
  'fabricated',
  'factual',
  'faded',
  'fading',
  'faint',
  'fair',
  'faithful',
  'fake',
  'fallen',
  'false',
  'familiar',
  'famous',
  'fanatical',
  'fancy',
  'faraway',
  'fashionable',
  'fast',
  'fat',
  'fatal',
  'fatherly',
  'faulty',
  'favorable',
  'favorite',
  'fearful',
  'fearless',
  'feathery',
  'feeble',
  'feisty',
  'feminine',
  'fertile',
  'festive',
  'fictional',
  'fierce',
  'fiery',
  'filmy',
  'filthy',
  'final',
  'financial',
  'fine',
  'finished',
  'fireproof',
  'firm',
  'fishy',
  'fixed',
  'fizzy',
  'flaky',
  'flammable',
  'flashy',
  'flat',
  'flavored',
  'flawed',
  'fleeting',
  'fleshy',
  'flexible',
  'flickering',
  'flimsy',
  'floating',
  'flooded',
  'floppy',
  'floral',
  'flourishing',
  'flowery',
  'flowing',
  'fluent',
  'fluffy',
  'fluorescent',
  'focused',
  'foggy',
  'folded',
  'foolish',
  'foolproof',
  'forceful',
  'foreign',
  'forested',
  'forgetful',
  'forked',
  'formal',
  'former',
  'fortunate',
  'fossilized',
  'foul',
  'fractured',
  'fragile',
  'fragmented',
  'fragrant',
  'frantic',
  'frayed',
  'freaky',
  'freckled',
  'free',
  'freezing',
  'frequent',
  'fresh',
  'friendly',
  'frightened',
  'frightening',
  'frigid',
  'frizzy',
  'frosty',
  'frothy',
  'frozen',
  'frugal',
  'fruity',
  'fulfilled',
  'full',
  'functional',
  'fundamental',
  'funky',
  'funny',
  'furious',
  'furry',
  'fussy',
  'fuzzy',
  'galactic',
  'gallant',
  'gangly',
  'garlicky',
  'gaseous',
  'gassy',
  'gaudy',
  'generic',
  'generous',
  'genetic',
  'gentle',
  'genuine',
  'geographical',
  'geometric',
  'germinated',
  'ghostly',
  'giant',
  'giddy',
  'gifted',
  'gigantic',
  'giggly',
  'gilded',
  'glacial',
  'glad',
  'glamorous',
  'glassy',
  'glazed',
  'gleaming',
  'glistening',
  'glittery',
  'global',
  'gloomy',
  'glorious',
  'glossy',
  'glowing',
  'gluey',
  'golden',
  'gooey',
  'goofy',
  'gorgeous',
  'gothic',
  'graceful',
  'gracious',
  'gradual',
  'grainy',
  'grand',
  'graphic',
  'grassy',
  'grateful',
  'grave',
  'gravel',
  'gray',
  'greasy',
  'greedy',
  'green',
  'grieving',
  'grilled',
  'grim',
  'grinding',
  'gripping',
  'gritty',
  'grizzled',
  'groggy',
  'groomed',
  'groovy',
  'gross',
  'grotesque',
  'grouchy',
  'grounded',
  'growing',
  'grubby',
  'grudging',
  'grumpy',
  'guaranteed',
  'guarded',
  'guilty',
  'gummy',
  'gushing',
  'gushy',
  'gusty',
  'gutsy',
  'habitual',
  'haggard',
  'hairy',
  'hallowed',
  'hammered',
  'handicapped',
  'handmade',
  'handsome',
  'handy',
  'happy',
  'hard',
  'hardened',
  'harmless',
  'harmonic',
  'harsh',
  'hasty',
  'haunted',
  'hazardous',
  'hazy',
  'healthy',
  'heartfelt',
  'hearty',
  'heated',
  'heavenly',
  'heavy',
  'hectic',
  'hefty',
  'helpful',
  'herbal',
  'heroic',
  'hesitant',
  'hexagonal',
  'hidden',
  'highborn',
  'hilarious',
  'hilly',
  'historic',
  'hoarse',
  'hollow',
  'homely',
  'homemade',
  'honest',
  'honeyed',
  'hopeful',
  'hopeless',
  'horizontal',
  'horned',
  'horrible',
  'horrific',
  'hostile',
  'hot',
  'hourly',
  'household',
  'howling',
  'huge',
  'humble',
  'humbled',
  'humid',
  'humming',
  'humorous',
  'hundredth',
  'hungry',
  'hushed',
  'husky',
  'hybrid',
  'hygienic',
  'icky',
  'icy',
  'ideal',
  'identical',
  'idle',
  'ignorant',
  'illegal',
  'illuminated',
  'illustrated',
  'imaginary',
  'imaginative',
  'immediate',
  'immense',
  'immersed',
  'immune',
  'impatient',
  'imperfect',
  'implied',
  'important',
  'imposing',
  'impossible',
  'impressive',
  'improved',
  'impulsive',
  'inadequate',
  'inclined',
  'incomplete',
  'incredible',
  'independent',
  'indicated',
  'indigo',
  'indirect',
  'individual',
  'indoor',
  'industrial',
  'inevitable',
  'inferior',
  'infinite',
  'inflated',
  'informal',
  'ingenious',
  'inhabited',
  'initial',
  'injured',
  'inland',
  'inner',
  'innocent',
  'innovative',
  'insane',
  'insecure',
  'insignificant',
  'inspired',
  'installed',
  'instant',
  'intellectual',
  'intelligent',
  'intended',
  'intense',
  'intentional',
  'interactive',
  'interesting',
  'intermediate',
  'internal',
  'intimate',
  'intricate',
  'invincible',
  'invisible',
  'iron',
  'irregular',
  'isolated',
  'issued',
  'itchy',
  'ivory',
  'jaded',
  'jagged',
  'jangling',
  'jarring',
  'jazzy',
  'jealous',
  'jerky',
  'jeweled',
  'jittery',
  'jolly',
  'jovial',
  'joyful',
  'juicy',
  'jumbled',
  'jumpy',
  'junior',
  'justified',
  'juvenile',
  'keen',
  'kind',
  'kindled',
  'kinetic',
  'kingly',
  'knitted',
  'knobby',
  'knotted',
  'labeled',
  'labored',
  'lacking',
  'lacy',
  'laden',
  'laminated',
  'landlocked',
  'lanky',
  'large',
  'lasting',
  'late',
  'lateral',
  'laughable',
  'lavish',
  'lawless',
  'layered',
  'lazy',
  'leading',
  'leafy',
  'leaky',
  'lean',
  'learned',
  'leathery',
  'leftover',
  'legal',
  'legendary',
  'legitimate',
  'leisurely',
  'lemony',
  'lengthy',
  'lesser',
  'lethal',
  'lettered',
  'level',
  'liberal',
  'lifeless',
  'light',
  'lightweight',
  'likely',
  'limited',
  'limitless',
  'limp',
  'linear',
  'lined',
  'lingering',
  'liquid',
  'literal',
  'literate',
  'little',
  'lively',
  'livid',
  'loaded',
  'local',
  'lofty',
  'logical',
  'lonely',
  'lonesome',
  'long',
  'loose',
  'lopsided',
  'lost',
  'loud',
  'lovable',
  'lovely',
  'loving',
  'lowly',
  'loyal',
  'lucky',
  'lukewarm',
  'lumpy',
  'lunar',
  'lurking',
  'lush',
  'lustful',
  'luxurious',
  'lyrical',
  'mad',
  'magenta',
  'magical',
  'magnetic',
  'magnificent',
  'mainland',
  'major',
  'makeshift',
  'malicious',
  'mammoth',
  'manageable',
  'mandatory',
  'mangy',
  'manufactured',
  'marble',
  'marine',
  'marked',
  'maroon',
  'married',
  'marvelous',
  'masculine',
  'masked',
  'massive',
  'material',
  'mature',
  'maximum',
  'meager',
  'mean',
  'meaningful',
  'measured',
  'meaty',
  'mechanical',
  'medical',
  'medieval',
  'mellow',
  'melted',
  'memorable',
  'menacing',
  'mental',
  'merciful',
  'mere',
  'merry',
  'messy',
  'metallic',
  'methodical',
  'metropolitan',
  'microscopic',
  'midday',
  'middle',
  'mighty',
  'migrating',
  'mild',
  'military',
  'milky',
  'mindful',
  'mineral',
  'miniature',
  'minimal',
  'minimum',
  'minor',
  'minty',
  'miraculous',
  'mirrored',
  'mischievous',
  'miserable',
  'misguided',
  'misleading',
  'missing',
  'misty',
  'mixed',
  'moaning',
  'mobile',
  'moderate',
  'modern',
  'modified',
  'moist',
  'moldy',
  'molten',
  'monthly',
  'monumental',
  'moody',
  'moonlit',
  'moral',
  'morbid',
  'mortal',
  'mossy',
  'motherly',
  'motionless',
  'motivated',
  'mountainous',
  'mournful',
  'mousy',
  'moving',
  'mucky',
  'muddy',
  'muffled',
  'muggy',
  'multiple',
  'mumbled',
  'murky',
  'muscular',
  'mushy',
  'musical',
  'musky',
  'musty',
  'muted',
  'mutual',
  'mysterious',
  'mystical',
  'naive',
  'naked',
  'nameless',
  'narrative',
  'narrow',
  'nasty',
  'national',
  'native',
  'natural',
  'naughty',
  'naval',
  'nearby',
  'neat',
  'necessary',
  'needless',
  'negative',
  'neglected',
  'neighboring',
  'nervous',
  'neutral',
  'new',
  'nightly',
  'nimble',
  'nippy',
  'noble',
  'noisy',
  'normal',
  'northern',
  'nosy',
  'notable',
  'noticed',
  'notorious',
  'novel',
  'nuclear',
  'null',
  'numb',
  'numbered',
  'numerous',
  'nutritious',
  'nutty',
  'obedient',
  'objective',
  'obligatory',
  'oblong',
  'obscure',
  'observant',
  'obsessive',
  'obsolete',
  'obvious',
  'occasional',
  'occupied',
  'odd',
  'offensive',
  'official',
  'oily',
  'old',
  'olive',
  'olympic',
  'ongoing',
  'opaque',
  'open',
  'operational',
  'opposing',
  'optimal',
  'optional',
  'oral',
  'orange',
  'ordered',
  'ordinary',
  'organic',
  'oriental',
  'original',
  'ornamental',
  'orthodox',
  'outdoor',
  'outer',
  'outgoing',
  'outlined',
  'outstanding',
  'oval',
  'overdue',
  'overgrown',
  'overhead',
  'overjoyed',
  'oversized',
  'overwhelming',
  'oxidized',
  'packed',
  'padded',
  'painful',
  'painted',
  'paired',
  'pale',
  'panicky',
  'panoramic',
  'papery',
  'parallel',
  'parched',
  'parental',
  'partial',
  'passionate',
  'passive',
  'pastel',
  'patchy',
  'pathetic',
  'patient',
  'patriotic',
  'patterned',
  'paved',
  'peaceful',
  'peach',
  'peaked',
  'pearly',
  'pebbly',
  'peculiar',
  'peeling',
  'peerless',
  'penetrating',
  'peppery',
  'peppy',
  'perfect',
  'periodic',
  'peripheral',
  'perky',
  'permanent',
  'permitted',
  'persistent',
  'personal',
  'persuasive',
  'pessimistic',
  'petite',
  'pharmaceutical',
  'phony',
  'physical',
  'pickled',
  'picky',
  'piercing',
  'pillowed',
  'pink',
  'pitiful',
  'pivotal',
  'plaid',
  'plain',
  'planned',
  'planted',
  'plastic',
  'playful',
  'pleasant',
  'pleasing',
  'plentiful',
  'plowed',
  'plugged',
  'plump',
  'plunging',
  'plush',
  'poetic',
  'pointed',
  'pointy',
  'poisonous',
  'polar',
  'polished',
  'polite',
  'political',
  'polluted',
  'pompous',
  'poor',
  'popular',
  'portable',
  'positive',
  'potent',
  'potential',
  'powdered',
  'powdery',
  'powerful',
  'practical',
  'prayerful',
  'preceding',
  'precious',
  'precise',
  'predictable',
  'predominant',
  'preferred',
  'pregnant',
  'prehistoric',
  'premature',
  'premium',
  'prepared',
  'prescribed',
  'present',
  'presidential',
  'pressing',
  'presumed',
  'pretty',
  'previous',
  'priceless',
  'pricey',
  'prickly',
  'primal',
  'primary',
  'prime',
  'primitive',
  'principal',
  'printed',
  'private',
  'probable',
  'productive',
  'professional',
  'profitable',
  'profound',
  'progressive',
  'prominent',
  'promising',
  'pronounced',
  'proper',
  'proportional',
  'proposed',
  'prosperous',
  'protective',
  'proud',
  'proven',
  'provincial',
  'provoking',
  'psychological',
  'public',
  'pudgy',
  'puffy',
  'pulpy',
  'punctual',
  'punctured',
  'punishing',
  'purchased',
  'pure',
  'purified',
  'purple',
  'purposeful',
  'puzzled',
  'qualified',
  'quarterly',
  'queasy',
  'queenly',
  'questionable',
  'quick',
  'quiet',
  'quilted',
  'quirky',
  'quotable',
  'racial',
  'radiant',
  'ragged',
  'raging',
  'rainy',
  'raised',
  'rambling',
  'rampant',
  'random',
  'ranging',
  'rapid',
  'rare',
  'rascally',
  'rash',
  'raspy',
  'rational',
  'rattling',
  'raw',
  'reactive',
  'readable',
  'real',
  'realistic',
  'reasonable',
  'rebellious',
  'recalled',
  'recent',
  'reckless',
  'recognized',
  'recovered',
  'rectangular',
  'recycled',
  'red',
  'reduced',
  'redundant',
  'refined',
  'reflected',
  'reformed',
  'refreshing',
  'regional',
  'registered',
  'regulated',
  'reinforced',
  'related',
  'relative',
  'relaxed',
  'released',
  'relevant',
  'reliable',
  'religious',
  'reluctant',
  'remaining',
  'remarkable',
  'remembered',
  'remote',
  'renewed',
  'renowned',
  'repaired',
  'repeated',
  'reported',
  'representative',
  'repulsive',
  'required',
  'reserved',
  'residential',
  'resistant',
  'resolved',
  'respective',
  'responsible',
  'restless',
  'restored',
  'restricted',
  'resulting',
  'retail',
  'retired',
  'retiring',
  'retro',
  'reusable',
  'revealing',
  'reversed',
  'revolving',
  'rewarding',
  'rhythmic',
  'rich',
  'ridged',
  'righteous',
  'rigid',
  'ripe',
  'rippled',
  'rising',
  'risky',
  'ritual',
  'rival',
  'roasted',
  'robotic',
  'robust',
  'rocky',
  'rolling',
  'romantic',
  'roomy',
  'rotating',
  'rotten',
  'rough',
  'round',
  'rounded',
  'routine',
  'royal',
  'rubber',
  'rubbery',
  'rude',
  'rugged',
  'ruined',
  'ruling',
  'rumbling',
  'running',
  'runny',
  'rural',
  'rushing',
  'rustling',
  'rusty',
  'ruthless',
  'sacred',
  'sacrificial',
  'sad',
  'saddened',
  'safe',
  'salted',
  'salty',
  'sampled',
  'sandstone',
  'sandy',
  'sane',
  'sassy',
  'satin',
  'satiny',
  'satisfied',
  'saturated',
  'savage',
  'savory',
  'scaly',
  'scarce',
  'scared',
  'scarlet',
  'scary',
  'scattered',
  'scenic',
  'scented',
  'scheduled',
  'scholarly',
  'scientific',
  'scorching',
  'scrappy',
  'scratchy',
  'scrawny',
  'screeching',
  'seasonal',
  'seasoned',
  'seated',
  'secondary',
  'secretive',
  'secured',
  'seismic',
  'selected',
  'selective',
  'selfish',
  'semiannual',
  'senior',
  'sensitive',
  'separate',
  'sequential',
  'serene',
  'serious',
  'settling',
  'seventh',
  'severe',
  'shabby',
  'shadowed',
  'shadowy',
  'shaggy',
  'shaky',
  'shallow',
  'shameful',
  'shapeless',
  'sharp',
  'shattered',
  'sheer',
  'sheltered',
  'shifting',
  'shimmering',
  'shiny',
  'shipwrecked',
  'shocking',
  'short',
  'shrill',
  'shrinking',
  'shuttered',
  'shy',
  'sick',
  'sickly',
  'sidelined',
  'significant',
  'silent',
  'silky',
  'silly',
  'silver',
  'simple',
  'simplified',
  'simultaneous',
  'sincere',
  'sinful',
  'single',
  'singular',
  'situated',
  'sizzling',
  'skeletal',
  'skilled',
  'skinny',
  'slanted',
  'slashed',
  'slated',
  'sleek',
  'sleeping',
  'sleepy',
  'slender',
  'sliding',
  'slim',
  'slimy',
  'slippery',
  'sloppy',
  'slow',
  'sluggish',
  'small',
  'smart',
  'smashed',
  'smelly',
  'smiling',
  'smokey',
  'smoking',
  'smoky',
  'smoldering',
  'smooth',
  'smothered',
  'smug',
  'snappy',
  'snarling',
  'snazzy',
  'sneaky',
  'snowy',
  'snug',
  'soaked',
  'soaking',
  'soaring',
  'sober',
  'social',
  'soft',
  'softened',
  'soggy',
  'solar',
  'sole',
  'solemn',
  'solid',
  'somber',
  'sometime',
  'soothing',
  'sophisticated',
  'sore',
  'sorry',
  'sorted',
  'soulful',
  'sour',
  'southern',
  'spacious',
  'sparkling',
  'sparse',
  'spatial',
  'special',
  'specific',
  'spectacular',
  'speedy',
  'spherical',
  'spicy',
  'spiky',
  'spinning',
  'spiraling',
  'spiritual',
  'splendid',
  'splitting',
  'spongy',
  'spontaneous',
  'spooky',
  'sporting',
  'spotless',
  'spotted',
  'sprawling',
  'springy',
  'sprinkled',
  'sprouting',
  'square',
  'squeaky',
  'stacked',
  'staggering',
  'stagnant',
  'stained',
  'stale',
  'standard',
  'standing',
  'stark',
  'starlit',
  'startled',
  'starving',
  'static',
  'stationed',
  'steadfast',
  'steady',
  'steaming',
  'steamy',
  'steel',
  'steep',
  'stellar',
  'sterile',
  'stern',
  'sticky',
  'stiff',
  'stimulating',
  'stinging',
  'stingy',
  'stinky',
  'stirring',
  'stocky',
  'stolen',
  'stomping',
  'stony',
  'stormy',
  'stout',
  'straight',
  'strained',
  'strange',
  'strategic',
  'streaming',
  'stressed',
  'stretchy',
  'strict',
  'striking',
  'stringy',
  'striped',
  'strong',
  'structural',
  'struggling',
  'stubborn',
  'stubby',
  'studious',
  'stuffed',
  'stuffy',
  'stumpy',
  'stunning',
  'stupid',
  'sturdy',
  'subdued',
  'subjected',
  'submarine',
  'submitted',
  'subsequent',
  'substantial',
  'subtle',
  'suburban',
  'successful',
  'sudden',
  'sufficient',
  'sugary',
  'suitable',
  'sulky',
  'sullen',
  'sultry',
  'summary',
  'sunken',
  'sunlit',
  'sunny',
  'super',
  'superb',
  'superior',
  'supplemental',
  'supported',
  'supposed',
  'supreme',
  'surgical',
  'surplus',
  'surprised',
  'surrounding',
  'surviving',
  'suspended',
  'suspicious',
  'sustained',
  'swampy',
  'sweaty',
  'sweet',
  'swift',
  'swollen',
  'symbolic',
  'sympathetic',
  'systematic',
  'tacky',
  'tactical',
  'tainted',
  'talented',
  'tall',
  'tame',
  'tan',
  'tangible',
  'tangled',
  'tangy',
  'targeted',
  'tart',
  'tasteful',
  'tasty',
  'tattered',
  'tawny',
  'tearful',
  'technical',
  'tedious',
  'tempting',
  'tender',
  'tense',
  'tepid',
  'terminal',
  'terrible',
  'terrific',
  'terrified',
  'territorial',
  'tested',
  'textured',
  'thankful',
  'theatrical',
  'therapeutic',
  'thermal',
  'thick',
  'thin',
  'thirsty',
  'thorny',
  'thorough',
  'thoughtful',
  'threadbare',
  'thrifty',
  'thrilling',
  'thriving',
  'thunderous',
  'ticking',
  'tidy',
  'tight',
  'timeless',
  'timid',
  'tinted',
  'tiny',
  'tired',
  'tireless',
  'toasty',
  'tolerable',
  'toothy',
  'topical',
  'tormented',
  'torn',
  'total',
  'touching',
  'tough',
  'towering',
  'toxic',
  'traditional',
  'tragic',
  'trained',
  'tranquil',
  'transient',
  'translucent',
  'transparent',
  'transplanted',
  'trapped',
  'treacherous',
  'tremendous',
  'trendy',
  'triangular',
  'tribal',
  'tricky',
  'trim',
  'triple',
  'triumphant',
  'trivial',
  'tropical',
  'troubled',
  'true',
  'trusty',
  'truthful',
  'tubby',
  'tumbling',
  'turbulent',
  'turning',
  'turquoise',
  'twilight',
  'twisted',
  'typical',
  'ugly',
  'ultimate',
  'unaffected',
  'unaware',
  'unbroken',
  'uncertain',
  'unchanged',
  'unclear',
  'uncommon',
  'unconventional',
  'uncovered',
  'undeniable',
  'underground',
  'underlying',
  'underrated',
  'understood',
  'underwater',
  'undeserved',
  'undiscovered',
  'undisputed',
  'undone',
  'unearthed',
  'uneven',
  'unexpected',
  'unfair',
  'unfamiliar',
  'unfinished',
  'unforgettable',
  'unfortunate',
  'unified',
  'unique',
  'universal',
  'unknown',
  'unlikely',
  'unlimited',
  'unmarked',
  'unmistakable',
  'unnamed',
  'unnoticed',
  'unofficial',
  'unpaid',
  'unpleasant',
  'unpopular',
  'unprecedented',
  'unreal',
  'unruly',
  'unseen',
  'unsettled',
  'unsigned',
  'unskilled',
  'unsolved',
  'unspoken',
  'unstable',
  'untamed',
  'untouched',
  'untrained',
  'unusual',
  'unveiled',
  'unwanted',
  'unwilling',
  'upbeat',
  'uphill',
  'upper',
  'upright',
  'upscale',
  'upset',
  'upward',
  'urban',
  'urgent',
  'useful',
  'useless',
  'utilized',
  'utmost',
  'utter',
  'vacant',
  'vague',
  'vain',
  'valuable',
  'vanilla',
  'variable',
  'varied',
  'vast',
  'velvet',
  'velvety',
  'vengeful',
  'venomous',
  'verbal',
  'verified',
  'vertical',
  'vibrant',
  'vicious',
  'victorious',
  'vintage',
  'violent',
  'violet',
  'virtual',
  'visible',
  'visual',
  'vital',
  'vivid',
  'vocal',
  'volatile',
  'volcanic',
  'voluntary',
  'vulgar',
  'vulnerable',
  'wandering',
  'waning',
  'wanting',
  'warlike',
  'warm',
  'warning',
  'warped',
  'warranted',
  'wary',
  'washed',
  'wasteful',
  'watchful',
  'watery',
  'wavy',
  'waxy',
  'weak',
  'wealthy',
  'weary',
  'weathered',
  'webbed',
  'weedy',
  'weekly',
  'weighted',
  'weird',
  'welcome',
  'western',
  'wet',
  'whiny',
  'whirling',
  'whispered',
  'whistling',
  'white',
  'whole',
  'wholesale',
  'wholesome',
  'wicked',
  'wide',
  'widened',
  'wild',
  'willing',
  'wilted',
  'winding',
  'windswept',
  'windy',
  'winged',
  'wintry',
  'wireless',
  'wiry',
  'wise',
  'withdrawn',
  'withered',
  'witnessed',
  'witty',
  'wizardly',
  'wobbly',
  'woeful',
  'wonderful',
  'wondrous',
  'wonky',
  'wooden',
  'woolly',
  'wordy',
  'worldly',
  'worn',
  'worried',
  'worthy',
  'wounded',
  'woven',
  'wrapped',
  'wrenching',
  'wrinkled',
  'writhing',
  'written',
  'wrong',
  'yawning',
  'yearly',
  'yellow',
  'yielding',
  'young',
  'youthful',
  'yucky',
  'zany',
  'zesty',
  'zigzag',
  'zippy',
];

export const RARE_ADJECTIVES = [
  'aberrant',
  'ablative',
  'abstemious',
  'abstruse',
  'acephalous',
  'acerbic',
  'acquisitive',
  'acrimonious',
  'adamantine',
  'adroit',
  'adumbral',
  'aegean',
  'aeolian',
  'aesthetic',
  'affable',
  'agrarian',
  'agrestic',
  'alacritous',
  'alchemical',
  'aleatory',
  'altricial',
  'amaranthine',
  'ambrosial',
  'ambulatory',
  'ameliorative',
  'amorphous',
  'amphibious',
  'anachronistic',
  'anechoic',
  'anfractuous',
  'anionic',
  'anodyne',
  'anserine',
  'antebellum',
  'antediluvian',
  'antipodean',
  'aphoristic',
  'apocryphal',
  'apodictic',
  'apostolic',
  'apotheotic',
  'aquiline',
  'arboreal',
  'arborescent',
  'arboretum',
  'arcadian',
  'arcane',
  'arcanist',
  'archipelagic',
  'arduous',
  'argent',
  'artisanal',
  'ascetic',
  'aseptic',
  'asinine',
  'assiduous',
  'astringent',
  'atavistic',
  'atonal',
  'august',
  'aureate',
  'auriferous',
  'auspicious',
  'austere',
  'autochthonous',
  'avuncular',
  'axiomatic',
  'bacchanalian',
  'baleful',
  'barometric',
  'basilican',
  'bathetic',
  'bathymetric',
  'beatific',
  'beguiling',
  'bellicose',
  'beneficent',
  'benighted',
  'benthic',
  'bicameral',
  'bifurcated',
  'bilious',
  'bimetallic',
  'bioluminescent',
  'bipartisan',
  'blithe',
  'bombastic',
  'borborygmic',
  'boreal',
  'bounteous',
  'brachial',
  'brackish',
  'bucolic',
  'bumptious',
  'burnished',
  'byzantine',
  'caducous',
  'calamitous',
  'calcareous',
  'calligraphic',
  'callous',
  'caloric',
  'calumnious',
  'campaniform',
  'canicular',
  'cankerous',
  'cantankerous',
  'capacious',
  'capricious',
  'captious',
  'cardinal',
  'cartographic',
  'cataclysmic',
  'cathartic',
  'caustic',
  'cavalier',
  'celestial',
  'cenobitic',
  'censorious',
  'centripetal',
  'cerulean',
  'chalcedonic',
  'chimerical',
  'chthonic',
  'churlish',
  'circuitous',
  'circumambient',
  'circumlunar',
  'circumscribed',
  'clairvoyant',
  'clandestine',
  'claviform',
  'clement',
  'climacteric',
  'cloistered',
  'coadjutant',
  'coalescing',
  'cogent',
  'colloquial',
  'comely',
  'commensurable',
  'commodious',
  'complaisant',
  'compunctious',
  'concatenated',
  'conciliatory',
  'concomitant',
  'conflated',
  'congenial',
  'consanguineous',
  'constellated',
  'consummate',
  'contiguous',
  'contrite',
  'contumacious',
  'convalescent',
  'convivial',
  'copious',
  'coriaceous',
  'corpulent',
  'corrigible',
  'coruscating',
  'corybantic',
  'cosmopolitan',
  'cotyledonous',
  'countervailing',
  'coxcombical',
  'craven',
  'crepuscular',
  'cruciform',
  'crystalline',
  'cunctative',
  'cuneiform',
  'cupreous',
  'cupriferous',
  'curmudgeonly',
  'cursory',
  'daedalian',
  'dastardly',
  'dauntless',
  'debonair',
  'decadent',
  'deciduous',
  'declamatory',
  'decoherent',
  'decrepit',
  'decussate',
  'defamatory',
  'defenestrated',
  'deferential',
  'defoliated',
  'deft',
  'deipnosophist',
  'deleterious',
  'deliquescent',
  'delphic',
  'demiurgic',
  'demure',
  'dendritic',
  'deprecatory',
  'derelict',
  'desultory',
  'devious',
  'diabolical',
  'diacritical',
  'diaphanous',
  'diatomic',
  'dichotomous',
  'didactic',
  'diffident',
  'dilatory',
  'diluvial',
  'diminutive',
  'dimorphic',
  'dioecious',
  'dioptric',
  'discalced',
  'disconsolate',
  'discordant',
  'discursive',
  'disingenuous',
  'dispendious',
  'dissolute',
  'dithyrambic',
  'diurnal',
  'doctrinaire',
  'dodecahedral',
  'doleful',
  'dolorous',
  'dorsiferous',
  'doughty',
  'draconian',
  'drupaceous',
  'dulcet',
  'dulcisonant',
  'duplicitous',
  'dyspeptic',
  'ebullient',
  'eburnean',
  'ecclesiastic',
  'ecclesiastical',
  'eclectic',
  'ecstatic',
  'ecumenical',
  'edacious',
  'effervescent',
  'efficacious',
  'efflorescent',
  'effulgent',
  'egregious',
  'eldritch',
  'eleemosynary',
  'elegiac',
  'elfin',
  'elliptical',
  'eluvial',
  'emaciated',
  'emancipated',
  'emendatory',
  'eminent',
  'emissary',
  'emollient',
  'empirical',
  'emunctory',
  'enamored',
  'endogenous',
  'enervating',
  'enigmatic',
  'ennervated',
  'entomological',
  'entomophagous',
  'ephemeral',
  'epicurean',
  'epigrammatic',
  'epistolary',
  'equanimous',
  'equestrian',
  'equivocal',
  'eremitic',
  'eristic',
  'erudite',
  'escarpment',
  'eschatological',
  'esculent',
  'esoteric',
  'estimable',
  'etesian',
  'ethereal',
  'etiolated',
  'etymological',
  'eudemonic',
  'eulogistic',
  'euphonious',
  'eutherian',
  'evanescent',
  'exacting',
  'exculpatory',
  'execrable',
  'exegetical',
  'exemplary',
  'exigent',
  'exiguous',
  'exogenous',
  'exorbitant',
  'expedient',
  'expiatory',
  'exsanguinated',
  'extant',
  'extemporaneous',
  'extraneous',
  'extravagant',
  'fabulist',
  'facetious',
  'factitious',
  'fallacious',
  'fastidious',
  'fatuous',
  'febrifugal',
  'febrile',
  'fecund',
  'feldspar',
  'felicitous',
  'fenestrated',
  'feral',
  'fervent',
  'fetid',
  'feudalistic',
  'fiduciary',
  'filiform',
  'fissiparous',
  'flagelliform',
  'flagitious',
  'flocculant',
  'florid',
  'fontinal',
  'forensic',
  'forficate',
  'forlorn',
  'formidable',
  'fossorial',
  'fractious',
  'frenetic',
  'friable',
  'frondescent',
  'fugacious',
  'fulgurating',
  'fuliginous',
  'fulsome',
  'fumarolic',
  'funereal',
  'furtive',
  'galvanic',
  'garnetiferous',
  'garrulous',
  'gasconading',
  'gauche',
  'gelastic',
  'gelatinous',
  'gelid',
  'genteel',
  'geodesic',
  'geomorphic',
  'geothermal',
  'geriatric',
  'germane',
  'gibbous',
  'glabrous',
  'glandular',
  'gnathic',
  'gnomic',
  'gonfalonic',
  'gossamer',
  'gramineous',
  'grandeval',
  'grandiloquent',
  'grandiose',
  'granivorous',
  'gratuitous',
  'gravimetric',
  'gregarious',
  'guileless',
  'gustatory',
  'gymnospermous',
  'gyroscopic',
  'hagiographic',
  'halcyon',
  'halftone',
  'hapless',
  'haptic',
  'haughty',
  'hebdomadal',
  'hedonistic',
  'heliacal',
  'heliocentric',
  'hendecagonal',
  'hermetic',
  'heterodox',
  'heuristic',
  'hieratic',
  'hirsute',
  'hoary',
  'holistic',
  'holographic',
  'homiletic',
  'hubristic',
  'hydraulic',
  'hymeneal',
  'hyperbolic',
  'hyperborean',
  'hypogeal',
  'hypostatic',
  'hypothermic',
  'ichthyological',
  'iconoclastic',
  'ideogrammatic',
  'ideographic',
  'idiosyncratic',
  'idyllic',
  'ignominious',
  'illustrious',
  'immaculate',
  'immemorial',
  'immutable',
  'impassive',
  'impecunious',
  'imperious',
  'imperturbable',
  'impervious',
  'impetuous',
  'implacable',
  'imponderable',
  'impregnable',
  'improvident',
  'impugnable',
  'incalculable',
  'incandescent',
  'incarnadine',
  'inchoate',
  'incipient',
  'incisive',
  'incommensurable',
  'incommodious',
  'incongruous',
  'incorporeal',
  'incorrigible',
  'indefatigable',
  'indelible',
  'indeterminate',
  'indigent',
  'indolent',
  'indurate',
  'inebriated',
  'ineffable',
  'ineluctable',
  'inestimable',
  'inexorable',
  'infrangible',
  'ingenuous',
  'inimical',
  'inimitable',
  'iniquitous',
  'innocuous',
  'inscrutable',
  'insidious',
  'insipid',
  'insouciant',
  'insuperable',
  'intercalary',
  'interlocutory',
  'interstitial',
  'intonational',
  'intractable',
  'intransigent',
  'intrepid',
  'inveterate',
  'invidious',
  'involucrate',
  'irascible',
  'iridescent',
  'irrefragable',
  'irresolute',
  'isobaric',
  'isomorphic',
  'isotropic',
  'itinerant',
  'jacobean',
  'jaunty',
  'jejune',
  'jocular',
  'jocund',
  'jubilant',
  'judicious',
  'jurisprudential',
  'juxtaposed',
  'kaleidoscopic',
  'kinesthetic',
  'labyrinthine',
  'lachrymose',
  'laconic',
  'lacustrine',
  'lambent',
  'languid',
  'languishing',
  'languorous',
  'lapidary',
  'lascivious',
  'latent',
  'latitudinarian',
  'laudable',
  'leonine',
  'lethargic',
  'levantine',
  'libellous',
  'libidinous',
  'licentious',
  'lichenous',
  'lilaceous',
  'lilliputian',
  'liminal',
  'limpid',
  'lissome',
  'lithographic',
  'litigious',
  'littoral',
  'logarithmic',
  'longitudinal',
  'loquacious',
  'lucent',
  'lucid',
  'lugubrious',
  'luminous',
  'lupine',
  'lurid',
  'lustrational',
  'lustrous',
  'luxuriant',
  'macabre',
  'macroscopic',
  'magisterial',
  'magnanimous',
  'magniloquent',
  'majestic',
  'majolica',
  'malarial',
  'maleficent',
  'malevolent',
  'malfeasant',
  'malodorous',
  'managerial',
  'maniacal',
  'manifest',
  'marsupial',
  'maudlin',
  'meandrous',
  'melancholic',
  'melismatic',
  'mellifluous',
  'mendacious',
  'mendicant',
  'mercurial',
  'meretricious',
  'meridional',
  'mesolithic',
  'metamorphic',
  'meticulous',
  'miasmic',
  'millenarian',
  'minatory',
  'ministerial',
  'mirthful',
  'misanthropic',
  'misogynistic',
  'modish',
  'mollifying',
  'monastic',
  'monolithic',
  'monosyllabic',
  'montane',
  'mordant',
  'moribund',
  'morose',
  'mulcting',
  'multifarious',
  'multivalent',
  'mundane',
  'municipal',
  'munificent',
  'mutable',
  'nacreous',
  'nascent',
  'nebulous',
  'necromantic',
  'nefarious',
  'negligible',
  'neolithic',
  'nephritic',
  'neurasthenic',
  'niggardly',
  'nitrogenous',
  'nocturnal',
  'noisome',
  'nomadic',
  'nonchalant',
  'nondescript',
  'notarial',
  'nubilous',
  'nugatory',
  'numinous',
  'obdurate',
  'obeisant',
  'oblique',
  'obsequious',
  'obstinate',
  'obstreperous',
  'obtuse',
  'oenological',
  'officious',
  'oleaginous',
  'oligarchic',
  'ominous',
  'omnipotent',
  'omniscient',
  'onerous',
  'onomatopoetic',
  'ontological',
  'opalescent',
  'operatic',
  'opprobrious',
  'opulent',
  'oracular',
  'orbicular',
  'ornate',
  'osmotic',
  'ossified',
  'ostensible',
  'ostentatious',
  'otherworldly',
  'otiose',
  'ovaloid',
  'overwrought',
  'pachydermal',
  'pacific',
  'palatial',
  'paleolithic',
  'palimpsestic',
  'palliative',
  'pallid',
  'palpable',
  'panegyric',
  'parabolic',
  'paradigmatic',
  'parlous',
  'parochial',
  'paroxysmal',
  'parsimonious',
  'pastoral',
  'patrician',
  'patulous',
  'peccadilloed',
  'peccant',
  'pedagogical',
  'pedantic',
  'pejorative',
  'pellucid',
  'pendulous',
  'pensive',
  'pentatonic',
  'penurious',
  'perambulatory',
  'percipient',
  'peregrine',
  'peremptory',
  'perfidious',
  'perfunctory',
  'peripatetic',
  'periphrastic',
  'permafrost',
  'pernicious',
  'perspicacious',
  'perspicuous',
  'pertinacious',
  'perturbative',
  'pestilential',
  'petulant',
  'philanthropic',
  'phlegmatic',
  'phonemic',
  'phosphorescent',
  'phylogenetic',
  'physiognomic',
  'piquant',
  'placid',
  'plaintive',
  'plangent',
  'platitudinous',
  'plebeian',
  'plenary',
  'pleonastic',
  'pliant',
  'pluvial',
  'pneumatic',
  'poignant',
  'polyglot',
  'ponderous',
  'pontifical',
  'portentous',
  'postdiluvian',
  'postprandial',
  'praetorian',
  'precipitous',
  'precocious',
  'prelapsarian',
  'prepossessing',
  'presumptuous',
  'preternatural',
  'prevaricating',
  'prevaricative',
  'primeval',
  'primogenitary',
  'pristine',
  'probative',
  'procrustean',
  'prodigal',
  'prodigious',
  'profligate',
  'profuse',
  'proleptic',
  'promethean',
  'promissory',
  'prophylactic',
  'propinquitous',
  'propitiatory',
  'propitious',
  'prosaic',
  'prostrate',
  'protean',
  'prototypical',
  'provident',
  'providential',
  'prudent',
  'prurient',
  'psychogenic',
  'puerile',
  'pugilistic',
  'pugnacious',
  'pulchritudinous',
  'punctilious',
  'pungent',
  'pusillanimous',
  'putrescent',
  'pyrrhic',
  'quadrilateral',
  'quaternary',
  'querulous',
  'quidditative',
  'quiescent',
  'quinquennial',
  'quisling',
  'quixotic',
  'quotidian',
  'raffish',
  'rambunctious',
  'rancorous',
  'rapacious',
  'rarefied',
  'recalcitrant',
  'recidivist',
  'recondite',
  'recrudescent',
  'rectitudinous',
  'redivivus',
  'redolent',
  'redoubtable',
  'refractary',
  'refractory',
  'refulgent',
  'regnant',
  'reliquary',
  'remonstrant',
  'renascent',
  'replete',
  'reproachful',
  'reprobate',
  'repugnant',
  'requisite',
  'resplendent',
  'restive',
  'reticent',
  'reticular',
  'retrogressive',
  'reverberant',
  'rhapsodic',
  'rhetorical',
  'ribald',
  'riposting',
  'risible',
  'rodomontade',
  'roguish',
  'roseate',
  'rotund',
  'rubescent',
  'rubicund',
  'rubiginous',
  'rueful',
  'ruminative',
  'rumpled',
  'rustic',
  'sabbatical',
  'saccharine',
  'sacramental',
  'sacrosanct',
  'sagacious',
  'salacious',
  'salient',
  'salubrious',
  'sanguine',
  'sapient',
  'sardonic',
  'sartorial',
  'saturnine',
  'scalene',
  'schismatic',
  'scintillating',
  'sclerotic',
  'scriptural',
  'scrupulous',
  'scurrilous',
  'sebaceous',
  'sedimentary',
  'sedulous',
  'semilunar',
  'senescent',
  'sententious',
  'sepulchral',
  'seraphic',
  'serpentine',
  'sesquipedalian',
  'sibilant',
  'sibylline',
  'simian',
  'sinecured',
  'sinuous',
  'solicitous',
  'solsticial',
  'somnolent',
  'sonorous',
  'sophomoric',
  'soporific',
  'specious',
  'splendiferous',
  'spurious',
  'staid',
  'stalwart',
  'stentorian',
  'stochastic',
  'stolid',
  'stoloniferous',
  'stratospheric',
  'strident',
  'stygian',
  'subcutaneous',
  'sublime',
  'sublunary',
  'subterfugal',
  'subterranean',
  'succulent',
  'sumptuous',
  'supercilious',
  'superfluous',
  'superlunary',
  'supernal',
  'suppliant',
  'surreptitious',
  'susurrant',
  'susurrous',
  'swarthy',
  'sybaritic',
  'sycophantic',
  'syllogistic',
  'symbiotic',
  'syncretic',
  'synoptic',
  'taciturn',
  'tangential',
  'tautological',
  'tawdry',
  'taxonomic',
  'temerarious',
  'tempestuous',
  'tenacious',
  'tendentious',
  'tendrilous',
  'tenebrous',
  'tergiversating',
  'terrestrial',
  'terse',
  'tessellated',
  'testamentary',
  'theocratic',
  'theopathic',
  'thespian',
  'thrasonical',
  'timorous',
  'titular',
  'topographical',
  'torpid',
  'tortuous',
  'totemic',
  'tractable',
  'transatlantic',
  'transcendent',
  'tremolant',
  'tremulous',
  'trenchant',
  'trepidatious',
  'troglodytic',
  'tropological',
  'truculent',
  'tumescent',
  'tumultuous',
  'turbid',
  'turbinate',
  'turgid',
  'tympanic',
  'tyrannical',
  'ubiquitous',
  'umbilical',
  'umbrageous',
  'unctuous',
  'undulating',
  'unfathomable',
  'ungainly',
  'unguicular',
  'unicameral',
  'unipolar',
  'unkempt',
  'unrequited',
  'urbane',
  'usurious',
  'utilitarian',
  'uxorious',
  'vacuous',
  'vagarious',
  'vainglorious',
  'valedictory',
  'valetudinarian',
  'vanquished',
  'vapid',
  'varicose',
  'variegated',
  'vascular',
  'vedantic',
  'vehement',
  'venal',
  'venerable',
  'ventricular',
  'veracious',
  'verdant',
  'veridical',
  'vermicular',
  'vernacular',
  'vesicular',
  'vestigial',
  'vexatious',
  'vicariate',
  'vicarious',
  'vigilant',
  'villainous',
  'vindictive',
  'virulent',
  'visceral',
  'viscous',
  'vitreous',
  'vitriolic',
  'vivacious',
  'vociferous',
  'voluminous',
  'voluptuous',
  'voracious',
  'votive',
  'vulcanized',
  'vulpine',
  'waiflike',
  'wanton',
  'waspish',
  'whimsical',
  'winsome',
  'wistful',
  'wizened',
  'wrathful',
  'wretched',
  'xanthic',
  'xenophobic',
  'xeric',
  'yeomanly',
  'yoked',
  'zealous',
  'zenlike',
  'zephyrous',
  'zoological',
];

const ALL_ADJECTIVES = [...COMMON_ADJECTIVES, ...RARE_ADJECTIVES];
export default ALL_ADJECTIVES;
